import React from 'react'

function Calidad({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" {...r}>
    <path
      stroke="#00033A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M48.5 19.51l-.09-3.18a1.947 1.947 0 00-1.95-1.89H13.08c-1.05 0-1.92.84-1.95 1.89L8.86 59.06c-.03 1.1.85 2 1.95 2h36.83c1.1 0 1.98-.9 1.95-2v-4.22m-28.36-40.8c0-5.76 2.47-10.43 8.23-10.43s8.23 4.67 8.23 10.43"
    ></path>
    <path
      stroke="#126FFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M49.13 48.88c6.33 0 11.46-5.13 11.46-11.46 0-6.33-5.13-11.46-11.46-11.46-6.33 0-11.46 5.13-11.46 11.46 0 6.33 5.13 11.46 11.46 11.46z"
    ></path>
    <path
      fill="#126FFF"
      d="M48.93 31.24l1.74 3.53 3.9.57-2.82 2.74.67 3.89-3.49-1.84-3.48 1.84.66-3.89-2.82-2.74 3.9-.57 1.74-3.53z"
    ></path>
    <path
      stroke="#00033A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21.16 20.3v-5.22m16.62 5.22v-5.22"
    ></path>
    <path
      fill="#00033A"
      d="M21.16 21.96a1.66 1.66 0 100-3.32 1.66 1.66 0 000 3.32zm16.68 0a1.66 1.66 0 100-3.32 1.66 1.66 0 000 3.32z"
    ></path>
  </svg>
  )
}

export default Calidad